export const signedIn = (user: any) => {
  console.log("Signed in. Current user:", user);
};

export const notSignedIn = () => {
  console.log("Not signed in");
};
